module.exports = __webpack_public_path__ + "img/maximize.7c9fe858.svg";